module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"save":"Сохранить","cancel":"Отмена","h1":"Изменить страницу"}}')
  delete Component.options._Ctor
}
